let webapi = (window.webapi = {});
window.myContext = {};
/**
 * 供客户端调用的接口
 *
 * pageTo:翻页    参数 pageIndex-页码
 * 定义位置：/src/components/RouteComponent/main
 *
 * evaluateResult:录音反馈  参数 total-总分 result-得分
 * 定义位置：/src/components/homeworkPage/homeworkPage
 */

export function apiDefine(...params) {
    params.forEach(opt => {
        const { apiName, fn } = opt;
        webapi[apiName] = fn;
    });
    
}
export function apiCancel(apiName) {
    delete webapi[apiName];
}

// apiDefine('sendClientData',function(res){
//     alert(1);
//     window.myContext = {};
//     if(res){
//         const data = JSON.parse(res);
//         window.myContext = {...window.myContext,...data};
//     }
// })
// alert(123)



// WEBPACK FOOTER //
// ./src/api/web.js